import { css, FlattenSimpleInterpolation } from 'styled-components';

export default function getTypographyColorStyles(color: string): FlattenSimpleInterpolation {
  return !color.includes('-gradient(')
    ? css`
        color: ${color};
      `
    : css`
        background: ${color};
        -webkit-text-fill-color: transparent;
        background-clip: text;
        -webkit-background-clip: text;
      `;
}
